import {postRequest} from "../util/http";

export const getWebConfig = async () => {
    return await postRequest('zs/pr/getWebConfig',{})
}


export const sendEmailCode = async (params) => {
    //email=邮箱&type=register
    return await postRequest('/zs/user/sendEmailCode',params)
}

export const accountRegister = async (params) => {
    //account=邮箱&password=111111&code=邮箱验证码
    return await postRequest('/zs/user/accountRegister',params)
}
export const forgotPassword = async (params) => {
    //account=邮箱&password=111111&code=邮箱验证码
    return await postRequest('/zs/user/forgotPassword',params)
}
